import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Auth';

export const login = async (formData) => {
    const result = await request.post(`${baseUrl}/AdminLogin`, formData);

    return result;
}

export const verify2FALogin = async (data) => {
    const result = await request.post(`${baseUrl}/Verify2FALogin`, data);

    return result;
}

export const logout = async () => {
    const result = await request.get(`${baseUrl}/Logout`);

    return result;
}
